import { Typography } from "@mui/material";
import React from "react";

export default function TextCustomerBankInfo({ children, ...props }) {
  return (
    <Typography
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
      }}
      variant="caption"
      color="#64748B"
      fontWeight={400}
    >
      {children}
    </Typography>
  );
}
